export default "__VITE_ASSET__BHG9iUY8__"